import { Routes } from '@angular/router';

import { AgregarPersonaComponent } from './features/agregar-persona/agregar-persona.component';
import { CONFIG_SECTION_DEFAULT } from './features/configuracion/configuracion-sections';
import { CongregacionComponent } from './features/congregacion/congregacion.component';
import { ContadorComponent } from './features/contador/contador.component';
import { GraficosComponent } from './features/graficos/graficos.component';
import { LiderComponent } from './features/lider/lider.component';
import { InicioComponent } from './features/inicio/inicio.component';
import { LoginComponent } from './features/login/login.component';
import { MuelleComponent } from './features/muelle/muelle.component';
import { EventosLiderComponent } from './features/lider/eventos/eventos-lider.component';
import { PapeleraComponent } from './features/papelera/papelera.component';
import { PerfilComponent } from './features/perfil/perfil.component';
import { SolicitudesComponent } from './features/solicitudes/solicitudes.component';
import { TomarListaComponent } from './features/tomar-lista/tomar-lista.component';
import { ShellLayoutComponent } from './core/layouts/shell-layout/shell-layout.component';
import { adminGuard } from './core/guards/admin.guard';
import { contadorGuard } from './core/guards/contador.guard';
import { graficosGuard } from './core/guards/graficos.guard';
import { perfilGuard } from './core/guards/perfil.guard';
import { agregarPersonaGuard } from './core/guards/agregar-persona.guard';
import { liderGuard, tomarListaGuard, eventosGuard, iglesiaEventosGuard } from './core/guards/lider.guard';
import { muelleGuard } from './core/guards/muelle.guard';
import { propiaCelulaGuard } from './core/guards/propia-celula.guard';
import { sessionGuard } from './core/guards/session.guard';
import { superpanelGuard } from './core/guards/superpanel.guard';
import { SuperpanelComponent } from './features/superpanel/superpanel.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: InicioComponent },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: ShellLayoutComponent,
    canActivate: [sessionGuard],
    children: [
      { path: 'superpanel', component: SuperpanelComponent, canActivate: [superpanelGuard] },
      { path: 'congregacion', component: CongregacionComponent, canActivate: [adminGuard] },
      { path: 'contador', component: ContadorComponent, canActivate: [contadorGuard] },
      { path: 'solicitudes', component: SolicitudesComponent, canActivate: [adminGuard] },
      { path: 'graficos', component: GraficosComponent, canActivate: [graficosGuard] },
      { path: 'papelera', component: PapeleraComponent, canActivate: [adminGuard] },
      { path: 'lider', component: LiderComponent, canActivate: [liderGuard, propiaCelulaGuard] },
      { path: 'tomar-lista', component: TomarListaComponent, canActivate: [tomarListaGuard, propiaCelulaGuard] },
      { path: 'muelle', component: MuelleComponent, canActivate: [muelleGuard] },
      { path: 'eventos', component: EventosLiderComponent, canActivate: [eventosGuard] },
      { path: 'agregar-persona', component: AgregarPersonaComponent, canActivate: [agregarPersonaGuard] },
      { path: 'editar-persona/:id', component: AgregarPersonaComponent, canActivate: [perfilGuard] },
      { path: 'perfil', component: PerfilComponent },
      {
        path: 'perfil/:personaId',
        component: PerfilComponent,
        canActivate: [perfilGuard],
      },
      {
        path: 'configuracion',
        loadComponent: () =>
          import('./features/configuracion/configuracion.component').then(
            (m) => m.ConfiguracionComponent,
          ),
        children: [
          { path: '', redirectTo: CONFIG_SECTION_DEFAULT, pathMatch: 'full' },
          {
            path: 'mi-cuenta',
            loadComponent: () =>
              import('./features/configuracion/sections/mi-cuenta/mi-cuenta.component').then(
                (m) => m.ConfiguracionMiCuentaComponent,
              ),
          },
          {
            path: 'mis-celulas',
            loadComponent: () =>
              import('./features/configuracion/sections/mis-celulas/mis-celulas.component').then(
                (m) => m.ConfiguracionMisCelulasComponent,
              ),
            canActivate: [liderGuard],
          },
          {
            path: 'notificaciones',
            loadComponent: () =>
              import('./features/configuracion/sections/notificaciones/notificaciones.component').then(
                (m) => m.ConfiguracionNotificacionesComponent,
              ),
          },
          {
            path: 'iglesia-funcionamiento',
            loadComponent: () =>
              import(
                './features/configuracion/sections/iglesia-funcionamiento/iglesia-funcionamiento.component'
              ).then((m) => m.ConfiguracionIglesiaFuncionamientoComponent),
            canActivate: [adminGuard],
          },
          {
            path: 'iglesia-reuniones',
            loadComponent: () =>
              import(
                './features/configuracion/sections/iglesia-reuniones/iglesia-reuniones.component'
              ).then((m) => m.ConfiguracionIglesiaReunionesComponent),
            canActivate: [adminGuard],
          },
          {
            path: 'iglesia-eventos',
            loadComponent: () =>
              import(
                './features/configuracion/sections/iglesia-eventos/iglesia-eventos.component'
              ).then((m) => m.ConfiguracionIglesiaEventosComponent),
            canActivate: [adminGuard, iglesiaEventosGuard],
          },
          {
            path: 'estado-servicio',
            loadComponent: () =>
              import(
                './features/configuracion/sections/estado-servicio/estado-servicio.component'
              ).then((m) => m.ConfiguracionEstadoServicioComponent),
            canActivate: [adminGuard],
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
